<template>
  <v-layout v-if="show" row justify-center>
    <v-card flat class="py-5">
      <template>
        <div class="text-center">
          <v-dialog v-model="show" width="600" v-show="show" persistent>
            <v-card>
              <v-img
                src="https://i.ibb.co/3B9f6m4/shark-and-shoal-02.jpg"
                aspect-ratio="2.75"
                class="white--text"
              >
                <v-container fill-height fluid>
                  <v-layout fill-height>
                    <v-flex xs12 align-end flexbox>
                      <span class="headline text--white"
                        >Você prefere estar no cardume ou ser Tubarão?</span
                      >
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-img>

              <v-card-title primary-title>
                <h3 class="headline mb-0">
                  Eu vou te ajudar e vou te transformar em Tubarão!
                </h3>
              </v-card-title>
              <v-card-text>
                Saia do cardume! Muitas pessoas vieram comigo e hoje já mudaram
                de vida! Comece <strong>HOJE</strong>! Faça diferente! E vire
                tubarão! Vamos pra cima!
              </v-card-text>
              <v-card-actions>
                <v-btn text color="secondary" @click="this.closeDialog"
                  >Continuar no cardume</v-btn
                >
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="this.closeDialog"
                  >Quero ser tubarão 🦈</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </template>
    </v-card>
  </v-layout>
</template>
<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    closeDialog() {
      this.$emit("close");
      this.show = false;
    },
  },
};
</script>
